<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
// Cabeçalho de identidade do cliente (avatar, estágio, nome e contato).
// Extraído de HistoricoCliente.vue mantendo classes, ordem do DOM e copy.
import { computed } from 'vue';
import LeadAvatar from './LeadAvatar.vue';
import LeadContextBadges from './LeadContextBadges.vue';
import {
  DEFAULT_PROFILE_STAGE_CLASS,
  PROFILE_STAGE_CLASS,
  STATUS_LABEL,
} from '../utils/leadHistoryConstants';

const props = defineProps({
  lead: { type: Object, required: true },
});

const profileStageClass = computed(
  () =>
    PROFILE_STAGE_CLASS[props.lead.qualification_status] ||
    DEFAULT_PROFILE_STAGE_CLASS
);

const stageLabel = computed(
  () => STATUS_LABEL[props.lead.qualification_status] || 'Estágio não informado'
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section class="rounded-lais border px-5 py-5" :class="profileStageClass">
    <div
      class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"
    >
      <div class="flex min-w-0 items-center gap-4">
        <LeadAvatar :lead="lead" size-class="size-14" />
        <div class="min-w-0">
          <p class="text-[12px] font-semibold uppercase opacity-75">
            {{ stageLabel }}
          </p>
          <h1 class="truncate font-redHatDisplay text-[24px] font-semibold">
            {{ lead.name || 'Cliente' }}
          </h1>
          <p class="mt-1 text-[13px] opacity-80">
            {{ lead.phone_number || lead.email || 'Contato não informado' }}
          </p>
        </div>
      </div>
      <LeadContextBadges :lead="lead" include-stage size="sm" />
    </div>
  </section>
</template>
